<div class="c-placeholder-skeleton">
	{{#if type === "header"}}
		<div class="skeleton-header">
			<div class="skeleton_animated"></div>
		</div>
	{{elseif type === "subheader"}}
		<div class="skeleton-subheader">
			<div class="skeleton-subheader_content-wrapper">
				<div class="skeleton_animated"></div>
			</div>
		</div>
	{{elseif type === "descr"}}
		<div class="skeleton-descr">
			<div class="skeleton_animated"></div>
			<div class="skeleton_animated"></div>
			<div class="skeleton_animated"></div>
		</div>
	{{elseif type === "list"}}
		<div class="skeleton-list">
			{{#each content}}
				<div class="skeleton-list_content-wrapper">
					<li><div class="skeleton_animated"></div></li>
				</div>
			{{/each}}
		</div>
	{{/if}}
</div>
